module.exports = __webpack_public_path__ + "static/media/207-Kuchen_ID_25.993e4f87.mp3";